/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SaveAffiliateProgramRequest
 */
export interface SaveAffiliateProgramRequest {
  /**
   * Email (валидация rfc/dns, до 254 символов)
   * @type {string}
   * @memberof SaveAffiliateProgramRequest
   */
  email: string
}

/**
 * Check if a given object implements the SaveAffiliateProgramRequest interface.
 */
export function instanceOfSaveAffiliateProgramRequest(
  value: object
): value is SaveAffiliateProgramRequest {
  if (!('email' in value) || value['email'] === undefined) return false
  return true
}

export function SaveAffiliateProgramRequestFromJSON(
  json: any
): SaveAffiliateProgramRequest {
  return SaveAffiliateProgramRequestFromJSONTyped(json, false)
}

export function SaveAffiliateProgramRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SaveAffiliateProgramRequest {
  if (json == null) {
    return json
  }
  return {
    email: json['email'],
  }
}

export function SaveAffiliateProgramRequestToJSON(
  value?: SaveAffiliateProgramRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    email: value['email'],
  }
}
